var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.82814 6.33536L5.29951 2.83398L1.09437 7.01529L1.09582 7.01674L0.880701 7.23079C0.743872 7.36694 0.649334 7.53981 0.608497 7.72855L0.0233119 10.433C-0.13067 11.1447 0.502211 11.7774 1.213 11.6223L3.91526 11.033C4.10254 10.9921 4.27413 10.8983 4.4096 10.7625L8.82814 6.33536Z",
    fill: "#3D464D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M9.21771 0.292702C8.82719 -0.0978226 8.19431 -0.0975296 7.80415 0.293356L7.77204 0.325528C7.7398 0.357829 7.71022 0.391787 7.68331 0.427127L7.67699 0.4208L6.12448 1.97618L9.66001 5.51171L11.2125 3.95633L11.2061 3.94996C11.2414 3.923 11.2753 3.89336 11.3076 3.86106L11.3397 3.82889C11.7298 3.438 11.7296 2.80455 11.339 2.41402L9.21771 0.292702Z",
    fill: "#3D464D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDark);
export default __webpack_public_path__ + "static/media/pencil-dark.26da40adf41a411a945519c0fa316a24.svg";
export { ForwardRef as ReactComponent };